<template>
  <control-base
    :config="conf"
    :dataType="dataType"
    :parentName="$options.name"
    @loaded="$emit('loaded', $event)"
    ref="base"
  >
    <template v-slot:filters>
      <div class="flex-col">
        <div class="flex-full">
          <p class="vertical-center">Property to display:</p>
          <drop-down
            class="w-full"
            :options="campaignProperties"
            :selected="conf.selectedProperty"
            @updateOption="selectItem"
            :placeholder="'Select a property'"
            :closeOnOutsideClick="true"
          />
        </div>
        <div class="warning" v-if="showWarning">
          This is the sum of all selected campaign's abandon rates, for the
          actual abandon rate % choose "OverallAbandonRate"
        </div>
      </div>

      <div
        class="flex-full"
        v-if="conf.selectedProperty == 'OverallAbandonRate'"
      >
        <p>Calculation:</p>
        <drop-down
          :options="calculations"
          :selected="conf.selectedCalculation"
          subProp="value"
          placeholder="None"
          @updateOption="selectCalculation"
          :closeOnOutsideClick="true"
        />
      </div>

      <div class="flex-full">
        <p class="vertical-center">Override Text:</p>
        <input v-model="conf.overrideText" />
      </div>
    </template>
    <template v-slot:control>
      <div class="prop-container" ref="container">
        <b class="header">
          <span v-multi-ref:resize>{{ displayText }}</span>
        </b>
        <b id="stat" style="text-align: center" class="stat"
          ><span v-multi-ref:resize>{{ value }}</span></b
        >
      </div>
    </template>
  </control-base>
</template>

<script>
// * Disabling eslint because we alter a property value within a computed prop
/* eslint-disable */
export default {
  name: "CampaignStatistic",

  props: {
    config: {
      required: true,
      value: Object,
    },

    shouldResize: {
      required: false,
      value: Boolean,
    },
  },

  watch: {
    shouldResize() {
      if (this.shouldResize) {
        this.$nextTick(() => this.resize());
      }
    },
  },

  data() {
    return {
      dataType: "campaign",
      campaignProperties: [
        "ConnectedCalls",
        "TotalCalls",
        "AbandonedCalls",
        "RunningAbandonRate",
        "OverallAbandonRate",
        "TotalCallsExcludingRobots",
      ],
      showWarning: false,
      calculations: [
        { key: "TotalCalls", value: "Abandoned/TotalCalls" },
        { key: "ConnectedCalls", value: "Abandoned/ConnectedCalls+Abandoned" },
      ],
    };
  },

  mounted() {
    this.registerDependencies();
    setTimeout(() => this.$nextTick(() => this.resize()), 200);
  },

  updated() {
    this.$nextTick(() => this.resize());
  },

  computed: {
    selectedProp() {
      return this.conf.selectedProperty;
    },

    conf() {
      return this.config; // Allows the parent to change the config reactively
    },

    filteredCampaigns() {
      return this.$store.getters.campaignData.filter((x) =>
        this.conf.campaignNames.includes(x.campaignName)
      );
    },

    value() {
      if (this.conf.selectedProperty == "Select Property") return "0";

      let res = 0;
      if (
        this.conf.selectedProperty == "OverallAbandonRate" &&
        this.conf.selectedCalculation
      ) {
        if (this.conf.selectedCalculation.key == "TotalCalls")
          res = this.getTotalOverall();
        if (this.conf.selectedCalculation.key == "ConnectedCalls")
          res = this.getConnectedOverall();
      } else
        res = this.sum(
          this.filteredCampaigns,
          this.fieldCase(this.conf.selectedProperty)
        );

      if (this.conf.selectedProperty.toLowerCase().includes("rate")) {
        if (this.conf.selectedProperty.toLowerCase().includes("running"))
          this.showWarning = true;
        else {
          res = Math.round(res * 100 * 100) / 100 + "%";
          this.showWarning = false;
        }
      } else this.showWarning = false;
      return res;
    },

    displayText() {
      return this.conf.overrideText
        ? this.conf.overrideText
        : this.conf.selectedProperty;
    },
  },

  methods: {
    registerDependencies() {
      this.$store.getters.campaignArgs.addProperty("CampaignName");

      if (this.conf.selectedProperty == "OverallAbandonRate") {
        this.$store.getters.campaignArgs.addProperty("ConnectedCalls");
        this.$store.getters.campaignArgs.addProperty("TotalCalls");
        this.$store.getters.campaignArgs.addProperty("AbandonedCalls");
      } else {
        this.$store.getters.campaignArgs.addProperty(
          this.conf.selectedProperty
        );
      }
    },

    getConnectedOverall() {
      var totalCalls = this.sum(this.filteredCampaigns, "connectedCalls");
      var abandoned = this.sum(this.filteredCampaigns, "abandonedCalls");
      return abandoned / (totalCalls + abandoned);
    },

    getTotalOverall() {
      var totalCalls = this.sum(this.filteredCampaigns, "totalCalls");
      var abandoned = this.sum(this.filteredCampaigns, "abandonedCalls");
      return abandoned / totalCalls;
    },

    selectItem(item) {
      if (this.conf.selectedProperty) {
        if (this.conf.selectedProperty == "OverallAbandonRate") {
          this.$store.getters.campaignArgs.removeProperty("ConnectedCalls");
          this.$store.getters.campaignArgs.removeProperty("TotalCalls");
          this.$store.getters.campaignArgs.removeProperty("AbandonedCalls");
        } else {
          this.$store.getters.campaignArgs.removeProperty(
            this.conf.selectedProperty
          );
        }
      }

      if (item == "OverallAbandonRate") {
        this.$store.getters.campaignArgs.addProperty("ConnectedCalls");
        this.$store.getters.campaignArgs.addProperty("TotalCalls");
        this.$store.getters.campaignArgs.addProperty("AbandonedCalls");
      } else {
        this.$store.getters.campaignArgs.addProperty(item);
      }

      this.conf.selectedProperty = item;
      this.$nextTick(() => this.resize());
    },

    resize() {
      this.resizeText({elements: this.$refs.resize});
      this.$emit("resized");
    },

    selectCalculation(val) {
      this.conf.selectedCalculation = val;
    },
  },
};
</script>

<style scoped>
.prop-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.header {
  height: 30%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat {
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 700;
}

.flex-full {
  display: flex;
  width: 100%;
  min-width: 400px;
  justify-content: space-between;
  margin: 5px 0;
}

.vertical-center {
  display: flex;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.warning {
  color: tomato;
  font-size: 13px;
  max-width: 400px;
  margin: 0 auto;
}
</style>